import { useNavigate } from "react-router-dom";
import HistoricBasicInformationSection from "../../../../features/bonds/shared/components/HistoricBasicInformationSection";
import { HISTORIC_BASIC_INFO_CONFIG } from "../../../../features/bonds/shared/historicBasicInformationConfig";

const ProbateHistoricBasicInformation = (props) => {
  const navigate = useNavigate();
  const config = { ...HISTORIC_BASIC_INFO_CONFIG.probate, navigate };
  return <HistoricBasicInformationSection config={config} {...props} />;
};

export default ProbateHistoricBasicInformation;
